export default {
  title: 'Prijsdetails',
  subtotal: 'Subtotaal',
  method_fee: 'Bezorgkosten',
  tip: 'Fooi',
  service_fee: 'Online verwerking',
  payment_method_upcharge_fee: 'PayPal-kosten',
  discount: 'Korting',
  taxes: 'Belastingen',
  total: 'Totaal',
};
